Bacon = require 'baconjs'
R = require 'ramda'

Globalize = require 'globalize'
Dispatcher = require 'utils/dispatcher'
restaurantStore = require 'stores/restaurant'

{ createResource, findResourceLink } = require 'utils/resources'
{ loadResourceFromURL } = require 'utils/resources2'


ORDERS_API = window.page_config.ORDERS_API || "/v4/orders.json"

d = new Dispatcher('payments')

createOrder = d.stream('pay-cart')
  .map R.assocPath(['order', 'cart_id'], R.__, url: ORDERS_API + "?ie=sucks")
  .flatMap createResource

tenders = createOrder
  .map findResourceLink('tenders', "get")
  .flatMap loadResourceFromURL
  .toEventStream()

addVaultToCards = (tender) ->
  if tender.id is 'CARD' and !tender.vault
    R.assoc "vault", { profiles: [] }, tender
  else
    tender

availableTenders = tenders
  .map R.prop('tenders')
  .map R.map addVaultToCards

addPaymentUrl = tenders
  .map findResourceLink('tenders', 'post')

addPayment = d.stream('create-payment')
  .debounce(500) # prevent double submit
  .map ({tenderId, tender, params, url}) ->
    url: url + "?ie=sucks"
    tender:
      id: tenderId
      params: params
  # INFO: To simulate errors uncomment next line and comment the remaining
  # .flatMap -> new Bacon.Error(status: {code: 422, message: "something wrong happend"})
  .flatMap createResource
  .map findResourceLink 'order', 'get'
  .flatMap loadResourceFromURL
  .map R.prop('order')

addPaymentError = addPayment
  .mapError R.map 'status'
  .map R.map 'message'

state = Bacon.update { order: null, tenders: [], tendersUrl: null },
  [ addPaymentUrl ], ( { tenders }, tendersUrl) ->
    { tenders, tendersUrl }

  [ availableTenders ], ( { tendersUrl }, tenders ) ->
    { tenders, tendersUrl }

  [ d.stream('add-payment') ], ( { order, tenders, tendersUrl }, { tenderId, params }) ->
    tender = R.find R.propEq('id', tenderId), tenders
    d.stream('create-payment').push { tenderId, params, tender, url: tendersUrl }
    { order, tenders, tendersUrl }

  [ addPayment ], ( { tenders, tendersUrl }, order) ->
    { order, tenders, tendersUrl }

payments = state
  .map R.prop('order')
  .filter R.compose R.not, R.isNil
  .map R.prop 'tender'
  .map R.flip(R.append)([])

order = createOrder
  .map findResourceLink("order", "get")
  .flatMap loadResourceFromURL
  .map R.prop('order')

user = order
  .map R.prop('customer')

restaurantStore.connect order.map(R.path(['restaurant', 'resource_url']))

module.exports =
  order: order
  user: user
  tenders: state.map R.prop('tenders')
  payCart: (cartId) -> d.stream('pay-cart').push cartId
  addPayment: (tenderId, params) ->
    d.stream('add-payment').push { tenderId, params }
    addPayment
  payments: payments
  error: addPaymentError
  purchaseResult: addPayment
